"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const z_index_1 = require("./internal/z.index");
function resultof(method, ...args) {
    return cacheof(method).getResult(...args);
}
exports.resultof = resultof;
function cacheof(method, ...args) {
    return Cache.get(method);
}
exports.cacheof = cacheof;
class Cache {
    static get(method) { return z_index_1.CachedResult.get(method); }
    static unmount(...objects) { return z_index_1.CachedResult.unmount(...objects); }
    static setTraceHint(obj, name) { z_index_1.Handle.setHint(obj, name); }
    static getTraceHint(obj) { return z_index_1.Handle.getHint(obj); }
}
exports.Cache = Cache;
